<template>
  <scrollable-container>
    <tabset :tabs="tabs" />
    <keep-alive>
      <router-view />
    </keep-alive>
  </scrollable-container>
</template>

<script>
import Tabset from '@/components/common/tabs/tabset.vue';
import ScrollableContainer from '@/components/common/blocks/scrollable-container.vue';

export default {
  components: {
    Tabset,
    ScrollableContainer,
  },
  data() {
    return {
      tabs: [
        {
          title: this.$t('reports.printerReport'),
          route: './printerReport',
        },
        {
          title: this.$t('reports.printedDocuments'),
          route: './printer-print-report',
          sortVariableName: 'PrintStatSortState',
        },
      ],
    };
  },
};
</script>
